import React from "react";
import DownloadIcon from "@material-ui/icons/CloudDownloadOutlined";
import ExcelIcon from "@material-ui/icons/TableChartOutlined";
import { IconButton } from "@material-ui/core";
import { CustomTooltip } from "../../../../components/common/CustomTooltip";
import { useOrderReportDownloader } from "../../../../../data/reports/exchbusiness/clientOverview/hooks/useOrderReportDownloader";
import { useOrderExcelReportDownloader } from "../../../../../data/reports/exchbusiness/clientOverview/hooks/useOrderExcelReportDownloader";

export const DownloadOrderButton: React.FunctionComponent = () => {
	const [downloader, fetchState] = useOrderReportDownloader();
	return (
		<CustomTooltip titleKeyword="exportPDFTooltip">
			<IconButton
				color="secondary"
				component="span"
				onClick={downloader}
				disabled={fetchState.type !== "not-started"}
			>
				<DownloadIcon />
			</IconButton>
		</CustomTooltip>
	);
};

export const DownloadOrderButtonExcel: React.FunctionComponent = () => {
	const [downloader, fetchState] = useOrderExcelReportDownloader();
	return (
		<CustomTooltip titleKeyword="exportXLSXTooltip">
			<IconButton
				color="secondary"
				component="span"
				onClick={downloader}
				disabled={fetchState.type !== "not-started"}
			>
				<ExcelIcon />
			</IconButton>
		</CustomTooltip>
	);
};
